module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.94846d76.woff";